import axios from "axios";
import ErrorParser from '../../services/error.parser';

const SensorService = {
  sensors: async function () {
    const requestData = {
      method: "get",
      url: "/api/sensors"
    };
    try {
      const response = await axios(requestData);

      return response.data; // Return the parsed object directly
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
};

export default SensorService;

